import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // 加载翻译文件的后端插件
  .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 将 i18n 实例传递给 react-i18next
  .init({
    supportedLngs: ['zh', 'en', 'ja', 'ko', 'th'], // 支持的语言列表
    fallbackLng: 'zh', // 如果检测不到用户语言或用户语言的翻译不存在，则使用的默认语言
    debug: process.env.NODE_ENV === 'development', // 开发模式下开启调试
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // 翻译文件的路径
    },
    interpolation: {
      escapeValue: false, // react已经处理了XSS，所以不需要再次转义
    },
    react: {
      useSuspense: true, // 使用 Suspense 进行懒加载翻译文件
    }
  });

export default i18n; 